import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AppProviders } from '@/providers/AppProviders';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import '@ckeditor/ckeditor5-build-classic/build/translations/pl';
import './assets/scss/theme.scss';
//for react-table
import 'regenerator-runtime/runtime';

if (import.meta.env.PROD) {
	disableReactDevTools();
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
	<AppProviders>
		<App />
	</AppProviders>
);
